import React from 'react';
import PropTypes from 'prop-types';
import Message from './message';

function SignupWidget(props) {
  return (
    <div className="signup-widget">
      <input
        type="email"
        id="email"
        className={`signup-widget__email ${
          props.emailEditable ? 'signup-widget__email--editable' : ''
        }`}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.handleChange}
        disabled={!props.emailEditable || props.disabled}
        ref={props.setFocus}
      />
      <label className="visually-hidden" htmlFor="email">
        Email
      </label>
      <button
        className={`signup-widget__button ${
          props.emailFormError ? 'signup-widget__button--disabled' : ''
        } ${
          props.emailEditable
            ? 'signup-widget__button--left-space'
            : `signup-widget__button--no-border`
        }`}
        onClick={props.emailEditable ? props.handleSubmit : props.toggleInputOn}
        disabled={props.emailFormError || props.disabled}
        type="button"
      >
        {props.buttonText}
      </button>
      <div className="signup-widget__message-container">
        <Message type="error" message={props.emailUpdateMessageError} />
        <Message type="success" message={props.emailUpdateSuccessMessage} />
        <Message type="error" message={props.emailFormError} />
      </div>
    </div>
  );
}

SignupWidget.defaultProps = {
  buttonText: 'Send',
  emailFormError: '',
  setFocus: () => {},
  emailUpdateMessageError: '',
  emailUpdateSuccessMessage: '',
  emailEditable: true,
  placeholder: 'You Email Address',
  toggleInputOn: () => {},
  disabled: false
};

SignupWidget.propTypes = {
  emailUpdateMessageError: PropTypes.string,
  emailUpdateSuccessMessage: PropTypes.string,
  emailEditable: PropTypes.bool,
  buttonText: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
  toggleInputOn: PropTypes.func,
  emailFormError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool
};

export default SignupWidget;



// WEBPACK FOOTER //
// ./src/views/components/newsletters/email_input.js